import chatbotRequest from '../http'
import type { UpdateChannelReq, UpdateChannelRes } from '../types/updateChannel'

export function updateChannelApi(data: UpdateChannelReq): Promise<UpdateChannelRes> {
    return chatbotRequest<UpdateChannelRes, UpdateChannelReq, UpdateChannelRes>({
        url: '/api/channel/update',
        method: 'post',
        data,
    })
}